import { render, staticRenderFns } from "./User_list.vue?vue&type=template&id=704e93fa&scoped=true&"
import script from "./User_list.vue?vue&type=script&lang=js&"
export * from "./User_list.vue?vue&type=script&lang=js&"
import style0 from "./User_list.vue?vue&type=style&index=0&id=704e93fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e93fa",
  null
  
)

export default component.exports